import { AwardEmbeds, listFlaggedAwards } from '@kudos/http-client'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export const FLAGGED_AWARDS_QK = 'FLAGGED_AWARDS_QUERY_KEY'

export const listFlaggedAwardsEmbeds: AwardEmbeds[] = ['sendToAndSender', 'badgeUrls']

export const useListFlaggedAwards = (tenantMemberId?: string) => {
  return useQuery({
    queryKey: [FLAGGED_AWARDS_QK, tenantMemberId],
    queryFn: () =>
      listFlaggedAwards({
        page: 1,
        pageSize: 100,
        sorting: ['-publishedAt'],
        embeds: listFlaggedAwardsEmbeds,
      }),
    placeholderData: keepPreviousData,
    select: data => data.results,
  })
}
